import { useSessionStorage } from "@vueuse/core";

export const selectedAccount = useSessionStorage('sa', null)
